var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbstractHalftoneDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.001 39.0714C162.466 39.8772 162.919 40.6909 163.36 41.5123C162.56 40.9887 162.025 40.0932 162.001 39.0714Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.574 18.3597C146.972 19.6716 148.328 21.0276 149.64 22.4256C149.133 23.3632 148.141 24 147 24C145.343 24 144 22.6569 144 21C144 19.8591 144.637 18.867 145.574 18.3597Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.488 4.6403C127.309 5.08096 128.123 5.534 128.929 5.99916C127.907 5.97531 127.011 5.44049 126.488 4.6403Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0714 5.99916C39.8772 5.534 40.6909 5.08096 41.5123 4.6403C40.9887 5.44049 40.0932 5.97531 39.0714 5.99916Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3597 22.4256C19.6716 21.0276 21.0276 19.6716 22.4256 18.3597C23.3632 18.867 24 19.8591 24 21C24 22.6569 22.6569 24 21 24C19.8591 24 18.867 23.3632 18.3597 22.4256Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6403 41.5123C5.08096 40.6909 5.534 39.8772 5.99916 39.0714C5.97531 40.0932 5.44049 40.9887 4.6403 41.5123Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.36 126.488C162.919 127.309 162.466 128.123 162.001 128.929C162.025 127.907 162.56 127.011 163.36 126.488Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.64 145.574C149.133 144.637 148.141 144 147 144C145.343 144 144 145.343 144 147C144 148.141 144.637 149.133 145.574 149.64C146.972 148.328 148.328 146.972 149.64 145.574Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.929 162.001C127.907 162.025 127.011 162.56 126.488 163.36C127.309 162.919 128.123 162.466 128.929 162.001Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5123 163.36C40.9887 162.56 40.0932 162.025 39.0714 162.001C39.8772 162.466 40.6909 162.919 41.5123 163.36Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4256 149.64C23.3632 149.133 24 148.141 24 147C24 145.343 22.6569 144 21 144C19.8591 144 18.867 144.637 18.3597 145.574C19.6716 146.972 21.0276 148.328 22.4256 149.64Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99916 128.929C5.97531 127.907 5.44049 127.011 4.6403 126.488C5.08096 127.309 5.534 128.123 5.99916 128.929Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3C60 4.65685 58.6569 6 57 6C55.3431 6 54 4.65685 54 3C54 1.34315 55.3431 0 57 0C58.6569 0 60 1.34315 60 3Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78 3C78 4.65685 76.6569 6 75 6C73.3431 6 72 4.65685 72 3C72 1.34315 73.3431 0 75 0C76.6569 0 78 1.34315 78 3Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96 3C96 4.65685 94.6569 6 93 6C91.3431 6 90 4.65685 90 3C90 1.34315 91.3431 0 93 0C94.6569 0 96 1.34315 96 3Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114 3C114 4.65685 112.657 6 111 6C109.343 6 108 4.65685 108 3C108 1.34315 109.343 0 111 0C112.657 0 114 1.34315 114 3Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21C42 22.6569 40.6569 24 39 24C37.3431 24 36 22.6569 36 21C36 19.3431 37.3431 18 39 18C40.6569 18 42 19.3431 42 21Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60 21C60 22.6569 58.6569 24 57 24C55.3431 24 54 22.6569 54 21C54 19.3431 55.3431 18 57 18C58.6569 18 60 19.3431 60 21Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21C78 22.6569 76.6569 24 75 24C73.3431 24 72 22.6569 72 21C72 19.3431 73.3431 18 75 18C76.6569 18 78 19.3431 78 21Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96 21C96 22.6569 94.6569 24 93 24C91.3431 24 90 22.6569 90 21C90 19.3431 91.3431 18 93 18C94.6569 18 96 19.3431 96 21Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114 21C114 22.6569 112.657 24 111 24C109.343 24 108 22.6569 108 21C108 19.3431 109.343 18 111 18C112.657 18 114 19.3431 114 21Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132 21C132 22.6569 130.657 24 129 24C127.343 24 126 22.6569 126 21C126 19.3431 127.343 18 129 18C130.657 18 132 19.3431 132 21Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24 39C24 40.6569 22.6569 42 21 42C19.3431 42 18 40.6569 18 39C18 37.3431 19.3431 36 21 36C22.6569 36 24 37.3431 24 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39C42 40.6569 40.6569 42 39 42C37.3431 42 36 40.6569 36 39C36 37.3431 37.3431 36 39 36C40.6569 36 42 37.3431 42 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60 39C60 40.6569 58.6569 42 57 42C55.3431 42 54 40.6569 54 39C54 37.3431 55.3431 36 57 36C58.6569 36 60 37.3431 60 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39C78 40.6569 76.6569 42 75 42C73.3431 42 72 40.6569 72 39C72 37.3431 73.3431 36 75 36C76.6569 36 78 37.3431 78 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96 39C96 40.6569 94.6569 42 93 42C91.3431 42 90 40.6569 90 39C90 37.3431 91.3431 36 93 36C94.6569 36 96 37.3431 96 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M114 39C114 40.6569 112.657 42 111 42C109.343 42 108 40.6569 108 39C108 37.3431 109.343 36 111 36C112.657 36 114 37.3431 114 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132 39C132 40.6569 130.657 42 129 42C127.343 42 126 40.6569 126 39C126 37.3431 127.343 36 129 36C130.657 36 132 37.3431 132 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150 39C150 40.6569 148.657 42 147 42C145.343 42 144 40.6569 144 39C144 37.3431 145.343 36 147 36C148.657 36 150 37.3431 150 39Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6 57C6 58.6569 4.65685 60 3 60C1.34315 60 0 58.6569 0 57C0 55.3431 1.34315 54 3 54C4.65685 54 6 55.3431 6 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57C24 58.6569 22.6569 60 21 60C19.3431 60 18 58.6569 18 57C18 55.3431 19.3431 54 21 54C22.6569 54 24 55.3431 24 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57C42 58.6569 40.6569 60 39 60C37.3431 60 36 58.6569 36 57C36 55.3431 37.3431 54 39 54C40.6569 54 42 55.3431 42 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57C60 58.6569 58.6569 60 57 60C55.3431 60 54 58.6569 54 57C54 55.3431 55.3431 54 57 54C58.6569 54 60 55.3431 60 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57C78 58.6569 76.6569 60 75 60C73.3431 60 72 58.6569 72 57C72 55.3431 73.3431 54 75 54C76.6569 54 78 55.3431 78 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57C96 58.6569 94.6569 60 93 60C91.3431 60 90 58.6569 90 57C90 55.3431 91.3431 54 93 54C94.6569 54 96 55.3431 96 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114 57C114 58.6569 112.657 60 111 60C109.343 60 108 58.6569 108 57C108 55.3431 109.343 54 111 54C112.657 54 114 55.3431 114 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M132 57C132 58.6569 130.657 60 129 60C127.343 60 126 58.6569 126 57C126 55.3431 127.343 54 129 54C130.657 54 132 55.3431 132 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150 57C150 58.6569 148.657 60 147 60C145.343 60 144 58.6569 144 57C144 55.3431 145.343 54 147 54C148.657 54 150 55.3431 150 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168 57C168 58.6569 166.657 60 165 60C163.343 60 162 58.6569 162 57C162 55.3431 163.343 54 165 54C166.657 54 168 55.3431 168 57Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M6 75C6 76.6569 4.65685 78 3 78C1.34315 78 0 76.6569 0 75C0 73.3431 1.34315 72 3 72C4.65685 72 6 73.3431 6 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24 75C24 76.6569 22.6569 78 21 78C19.3431 78 18 76.6569 18 75C18 73.3431 19.3431 72 21 72C22.6569 72 24 73.3431 24 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42 75C42 76.6569 40.6569 78 39 78C37.3431 78 36 76.6569 36 75C36 73.3431 37.3431 72 39 72C40.6569 72 42 73.3431 42 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75C60 76.6569 58.6569 78 57 78C55.3431 78 54 76.6569 54 75C54 73.3431 55.3431 72 57 72C58.6569 72 60 73.3431 60 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75C78 76.6569 76.6569 78 75 78C73.3431 78 72 76.6569 72 75C72 73.3431 73.3431 72 75 72C76.6569 72 78 73.3431 78 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75C96 76.6569 94.6569 78 93 78C91.3431 78 90 76.6569 90 75C90 73.3431 91.3431 72 93 72C94.6569 72 96 73.3431 96 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M114 75C114 76.6569 112.657 78 111 78C109.343 78 108 76.6569 108 75C108 73.3431 109.343 72 111 72C112.657 72 114 73.3431 114 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M132 75C132 76.6569 130.657 78 129 78C127.343 78 126 76.6569 126 75C126 73.3431 127.343 72 129 72C130.657 72 132 73.3431 132 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M150 75C150 76.6569 148.657 78 147 78C145.343 78 144 76.6569 144 75C144 73.3431 145.343 72 147 72C148.657 72 150 73.3431 150 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M168 75C168 76.6569 166.657 78 165 78C163.343 78 162 76.6569 162 75C162 73.3431 163.343 72 165 72C166.657 72 168 73.3431 168 75Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6 93C6 94.6569 4.65685 96 3 96C1.34315 96 0 94.6569 0 93C0 91.3431 1.34315 90 3 90C4.65685 90 6 91.3431 6 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93C24 94.6569 22.6569 96 21 96C19.3431 96 18 94.6569 18 93C18 91.3431 19.3431 90 21 90C22.6569 90 24 91.3431 24 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42 93C42 94.6569 40.6569 96 39 96C37.3431 96 36 94.6569 36 93C36 91.3431 37.3431 90 39 90C40.6569 90 42 91.3431 42 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93C60 94.6569 58.6569 96 57 96C55.3431 96 54 94.6569 54 93C54 91.3431 55.3431 90 57 90C58.6569 90 60 91.3431 60 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93C78 94.6569 76.6569 96 75 96C73.3431 96 72 94.6569 72 93C72 91.3431 73.3431 90 75 90C76.6569 90 78 91.3431 78 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M96 93C96 94.6569 94.6569 96 93 96C91.3431 96 90 94.6569 90 93C90 91.3431 91.3431 90 93 90C94.6569 90 96 91.3431 96 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M114 93C114 94.6569 112.657 96 111 96C109.343 96 108 94.6569 108 93C108 91.3431 109.343 90 111 90C112.657 90 114 91.3431 114 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M132 93C132 94.6569 130.657 96 129 96C127.343 96 126 94.6569 126 93C126 91.3431 127.343 90 129 90C130.657 90 132 91.3431 132 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M150 93C150 94.6569 148.657 96 147 96C145.343 96 144 94.6569 144 93C144 91.3431 145.343 90 147 90C148.657 90 150 91.3431 150 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M168 93C168 94.6569 166.657 96 165 96C163.343 96 162 94.6569 162 93C162 91.3431 163.343 90 165 90C166.657 90 168 91.3431 168 93Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6 111C6 112.657 4.65685 114 3 114C1.34315 114 0 112.657 0 111C0 109.343 1.34315 108 3 108C4.65685 108 6 109.343 6 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24 111C24 112.657 22.6569 114 21 114C19.3431 114 18 112.657 18 111C18 109.343 19.3431 108 21 108C22.6569 108 24 109.343 24 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42 111C42 112.657 40.6569 114 39 114C37.3431 114 36 112.657 36 111C36 109.343 37.3431 108 39 108C40.6569 108 42 109.343 42 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60 111C60 112.657 58.6569 114 57 114C55.3431 114 54 112.657 54 111C54 109.343 55.3431 108 57 108C58.6569 108 60 109.343 60 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111C78 112.657 76.6569 114 75 114C73.3431 114 72 112.657 72 111C72 109.343 73.3431 108 75 108C76.6569 108 78 109.343 78 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M96 111C96 112.657 94.6569 114 93 114C91.3431 114 90 112.657 90 111C90 109.343 91.3431 108 93 108C94.6569 108 96 109.343 96 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M114 111C114 112.657 112.657 114 111 114C109.343 114 108 112.657 108 111C108 109.343 109.343 108 111 108C112.657 108 114 109.343 114 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M132 111C132 112.657 130.657 114 129 114C127.343 114 126 112.657 126 111C126 109.343 127.343 108 129 108C130.657 108 132 109.343 132 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M150 111C150 112.657 148.657 114 147 114C145.343 114 144 112.657 144 111C144 109.343 145.343 108 147 108C148.657 108 150 109.343 150 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M168 111C168 112.657 166.657 114 165 114C163.343 114 162 112.657 162 111C162 109.343 163.343 108 165 108C166.657 108 168 109.343 168 111Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24 129C24 130.657 22.6569 132 21 132C19.3431 132 18 130.657 18 129C18 127.343 19.3431 126 21 126C22.6569 126 24 127.343 24 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42 129C42 130.657 40.6569 132 39 132C37.3431 132 36 130.657 36 129C36 127.343 37.3431 126 39 126C40.6569 126 42 127.343 42 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M60 129C60 130.657 58.6569 132 57 132C55.3431 132 54 130.657 54 129C54 127.343 55.3431 126 57 126C58.6569 126 60 127.343 60 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M78 129C78 130.657 76.6569 132 75 132C73.3431 132 72 130.657 72 129C72 127.343 73.3431 126 75 126C76.6569 126 78 127.343 78 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M96 129C96 130.657 94.6569 132 93 132C91.3431 132 90 130.657 90 129C90 127.343 91.3431 126 93 126C94.6569 126 96 127.343 96 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M114 129C114 130.657 112.657 132 111 132C109.343 132 108 130.657 108 129C108 127.343 109.343 126 111 126C112.657 126 114 127.343 114 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M132 129C132 130.657 130.657 132 129 132C127.343 132 126 130.657 126 129C126 127.343 127.343 126 129 126C130.657 126 132 127.343 132 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M150 129C150 130.657 148.657 132 147 132C145.343 132 144 130.657 144 129C144 127.343 145.343 126 147 126C148.657 126 150 127.343 150 129Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M42 147C42 148.657 40.6569 150 39 150C37.3431 150 36 148.657 36 147C36 145.343 37.3431 144 39 144C40.6569 144 42 145.343 42 147Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M60 147C60 148.657 58.6569 150 57 150C55.3431 150 54 148.657 54 147C54 145.343 55.3431 144 57 144C58.6569 144 60 145.343 60 147Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M78 147C78 148.657 76.6569 150 75 150C73.3431 150 72 148.657 72 147C72 145.343 73.3431 144 75 144C76.6569 144 78 145.343 78 147Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M96 147C96 148.657 94.6569 150 93 150C91.3431 150 90 148.657 90 147C90 145.343 91.3431 144 93 144C94.6569 144 96 145.343 96 147Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M114 147C114 148.657 112.657 150 111 150C109.343 150 108 148.657 108 147C108 145.343 109.343 144 111 144C112.657 144 114 145.343 114 147Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M132 147C132 148.657 130.657 150 129 150C127.343 150 126 148.657 126 147C126 145.343 127.343 144 129 144C130.657 144 132 145.343 132 147Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M60 165C60 166.657 58.6569 168 57 168C55.3431 168 54 166.657 54 165C54 163.343 55.3431 162 57 162C58.6569 162 60 163.343 60 165Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M78 165C78 166.657 76.6569 168 75 168C73.3431 168 72 166.657 72 165C72 163.343 73.3431 162 75 162C76.6569 162 78 163.343 78 165Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M96 165C96 166.657 94.6569 168 93 168C91.3431 168 90 166.657 90 165C90 163.343 91.3431 162 93 162C94.6569 162 96 163.343 96 165Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M114 165C114 166.657 112.657 168 111 168C109.343 168 108 166.657 108 165C108 163.343 109.343 162 111 162C112.657 162 114 163.343 114 165Z",
    fill: "#00DAC2",
    fillOpacity: 0.48
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractHalftoneDots);
export default __webpack_public_path__ + "static/media/abstract_halftone_dots.697e4867.svg";
export { ForwardRef as ReactComponent };